// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5882018f","885":"09ed2374","977":"f2cdc51f"}[chunkId] + ".chunk.js";
};